<template>
    <div
        class="fixed inset-0 z-50 flex justify-end bg-black/20"
        @click.self="$emit('close')"
    >
        <div class="bg-white w-full max-w-md border-l border-gray-200 shadow-2xl flex flex-col">
            <!-- Header -->
            <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 flex-shrink-0">
                <h2 class="text-lg font-semibold text-gray-900"><i class="fa-duotone fa-solid fa-clock-rotate-left text-primary-500 mr-2"></i>Email History</h2>
                <button
                    class="text-gray-400 hover:text-gray-600 transition-colors"
                    @click="$emit('close')"
                >
                    <i class="fa-solid fa-xmark text-lg"></i>
                </button>
            </div>

            <!-- Content -->
            <div class="flex-1 overflow-y-auto px-6 py-4">
                <!-- Loading skeletons -->
                <div v-if="loading" class="space-y-3">
                    <div
                        v-for="i in 5"
                        :key="i"
                        class="bg-gray-50 rounded-lg p-4 animate-pulse space-y-2"
                    >
                        <div class="h-4 bg-gray-200 rounded w-3/4"></div>
                        <div class="h-3 bg-gray-200 rounded w-1/2"></div>
                        <div class="h-3 bg-gray-100 rounded w-full"></div>
                    </div>
                </div>

                <!-- Empty state -->
                <div
                    v-else-if="logs.length === 0"
                    class="text-center text-gray-400 py-12"
                >
                    <i class="fa-duotone fa-solid fa-inbox text-3xl text-gray-300 mb-3"></i><br>
                    No emails sent yet
                </div>

                <!-- Log list -->
                <div v-else class="space-y-3">
                    <div
                        v-for="log in logs"
                        :key="log.id"
                        class="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:border-gray-300 transition-colors space-y-1"
                    >
                        <div class="flex items-start justify-between gap-2">
                            <span class="text-sm font-medium text-gray-900 truncate">
                                {{ log.recipient_name }}
                            </span>
                            <span class="text-xs text-gray-400 flex-shrink-0">
                                {{ formatDate(log.created_at) }}
                            </span>
                        </div>
                        <p class="text-sm text-gray-600 truncate">{{ log.subject }}</p>
                        <div class="flex items-center gap-2 text-xs text-gray-400">
                            <span class="bg-primary-50 text-primary-600 px-1.5 py-0.5 rounded font-medium">{{ log.purpose }}</span>
                            <span>&middot;</span>
                            <span class="truncate">{{ log.recipient_email }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailHistoryDrawer',
    emits: ['close'],
    data() {
        return { logs: [], loading: true };
    },
    mounted() {
        this.fetchHistory();
    },
    methods: {
        async fetchHistory() {
            try {
                const response = await fetch('/admin/email-composer/history');
                const json = await response.json();
                if (json.data && Array.isArray(json.data.data)) {
                    this.logs = json.data.data;
                } else if (json.data && Array.isArray(json.data)) {
                    this.logs = json.data;
                } else {
                    this.logs = [];
                }
            } catch (error) {
                console.error('Failed to load email history:', error);
                this.logs = [];
            } finally {
                this.loading = false;
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            const month = date.toLocaleString('en-US', { month: 'short' });
            const day = date.getDate();
            const hours = date.getHours();
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const hour12 = hours % 12 || 12;
            return `${month} ${day}, ${hour12}:${minutes} ${ampm}`;
        },
    },
};
</script>
